export const KeycloakGroupMappings = {
  add_contact_off: "連絡先追加",
  agreement_off: "利用規約",
  all_off: "全タブ",
  bookmarks_off: "ブックマークタブ",
  connect_talk_off: "Connect Talk",
  create_bookmarks_off: "ブックマーク作成",
  edit_account_off: "アカウント編集",
  edit_contact_detail_screen_off: "連絡先編集",
  email_button_off: "メールボタン表示",
  external_call_detail_screen_off: "外線通話詳細画面",
  external_outgoing_call_button_off: "外線発信ボタン",
  import_vcf_off: "VCFインポート",
  incoming_call_phonebook_sync_off: "着信時電話帳同期",
  internal_off: "社内電話帳",
  landline_call_button_off: "固定電話送信ボタン",
  local_phone_import_off: "ローカル電話帳インポート",
  mojiokoshi_off: "一斉発信の文字起こし",
  personal_phonebook_off: "個人電話帳",
  save_indvidual_off: "個人電話帳保存",
  save_shared_off: "共通電話帳保存",
  send_broadcast_off: "一斉発信送信",
  send_email_detail_screen_off: "メール送信",
  shared_phonebook_off: "共通電話帳",
  tenant: "YOBELY設定", // temp set as YOBELY settings
  update_passcode_off: "パスコード更新",
  user_access_off: "ユーザーアクセス",
  view_meishi_import_menu_off: "名刺インポートメニュー閲覧",
  view_phonebook_off: "電話帳閲覧",
  view_service_manual_off: "サービスマニュアル閲覧",
  view_settings_menu_off: "設定メニュー閲覧",
  view_users_off: "ユーザー一覧",
  yobely: "YOBELY",
};

export const keycloakSubGroupMappings = {
  data: "データ",
  global: "グローバル",
  settings: "設定",
  incom: "一斉発信",
};
